import React from 'react';

interface BaseImageCardProps {
  imageUrl: string;
  onClick?: () => void;
  backgroundSize?: 'cover' | 'contain';
}

const baseCardStyle = {
  marginTop: '0',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
};

const BaseImageCard = ({
  imageUrl,
  onClick,
  backgroundSize = 'cover',
}: BaseImageCardProps) => {
  return (
    <div
      onClick={onClick}
      className="rounded-xl shrink-0 flex flex-col overflow-hidden w-[7rem] h-[5.75rem]"
      style={{
        ...baseCardStyle,
        backgroundImage: `url(${imageUrl})`,
        backgroundSize,
      }}
    />
  );
};

export default BaseImageCard;
